import type { Block } from '@pageboss/shared';
import { InspectorSection } from './inspector-section';
import { InspectorField } from './inspector-field';
import { Toggle } from './toggle';

type LocationsBlock = Extract<Block, { type: 'locations' }>;
type LocationsProps = LocationsBlock['props'];

// Multi-location phase, Task 9 — Scenario B. Deliberately the smallest
// inspector in the library: the block carries NO member data (name/address/
// phone are resolved server-side at render, org+group-scoped — see
// apps/renderer/src/locations-helpers.ts), so there's nothing here to edit
// but the section heading and the phone-display toggle.
interface LocationsInspectorProps {
  block: LocationsBlock;
  onChange: (next: LocationsProps) => void;
}

export function LocationsInspector({ block, onChange }: LocationsInspectorProps) {
  const props = block.props;
  const patch = (next: Partial<LocationsProps>) => onChange({ ...props, ...next });

  return (
    <>
      <InspectorSection>
        <InspectorField
          label="Heading"
          value={props.heading}
          placeholder="Our locations"
          onChange={(v) => patch({ heading: v || 'Our locations' })}
        />
      </InspectorSection>

      <InspectorSection label="Display">
        <Toggle
          label="Show phone numbers"
          description="Adds a phone number below each location's address, when that location has one"
          checked={props.showPhones}
          onChange={(checked) => patch({ showPhones: checked })}
        />
      </InspectorSection>
    </>
  );
}
